var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSoundOff24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.715 3.295 20.7 17.285a1 1 0 0 1-1.32 1.498l-.094-.084L16 15.412V20a1 1 0 0 1-.883.993L15 21c-.642 0-1.258-.25-1.72-.695L7.79 15H5a2 2 0 0 1-2-2v-2a2 2 0 0 1 2-2h2.765l.93-.896L5.301 4.71a1 1 0 0 1 1.414-1.415ZM15 3a1 1 0 0 1 1 1v5.76l-4.426-4.426 1.705-1.64c.416-.401.958-.642 1.53-.687L15 3Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoundOff24);
export default __webpack_public_path__ + "static/media/sound_off_24.66a6fb73.svg";
export { ForwardRef as ReactComponent };